//import React from "react";

import { ReactElement } from "react";

// STYLES
import "./IconButton.scss";

interface IIconButtonProps {
    className?: string;
    text?: string; // omit if only want the icon as the button
    icon: ReactElement<SVGSVGElement>;
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    [key: string]: any;
}

const IconButton: React.FC<IIconButtonProps> = ({
    className = "",
    text,
    icon,
    onClick,
    ...rest
}) => {
    return (
        <div className={`IconButton ${className}`} {...rest}>
            <div className="IconButton__content">
                <button onClick={onClick}>
                    {icon}
                    {text}
                </button>
            </div>
        </div>
    );
};

export default IconButton;
